import React from 'react';
import { withLazyComponent } from './with-lazy-component';

const Component = React.lazy(() => import('../components/checkbox/tiny-checkbox'));

export default function (dependencies) {
  var config = {
    defaultValue: 'false',
  };

  const html = (props) => {
    const LazyComponent = withLazyComponent(Component);
    return LazyComponent({ ...dependencies, ...props });
  };

  return {
    html,
    config: config,
  };
}
